import styles from './AttributionRow.module.css';

export interface AttributionItem {
  label: string;
  value: string;
}

interface AttributionRowProps {
  items: AttributionItem[];
}

export function AttributionRow({ items }: AttributionRowProps) {
  return (
    <dl className={styles.row}>
      {items.map((item) => (
        <div className={styles.item} key={item.label}>
          <dt className={styles.label}>{item.label}</dt>
          <dd className={styles.value}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
